import React from 'react';
import Typography from '@material-ui/core/Typography';

import { Api } from '../../utils/api';

export class CountyView extends React.Component {
  state = {
    county: null
  };

  constructor() {
    super();
    this.api = new Api();
  }

  componentDidMount() {
    const { id } = this.props;
    if(!id) return;
    this.api.get(`/counties/${id}`)
      .then(({data: county}) => {
        this.setState({ county });
      });
  }

  render() {
    return (
      <Typography inline variant="body2">
        {this.state.county ? this.state.county.name : 'Loading County'}{this.props.comma ? ', ': ''}
      </Typography>
    );
  }
}
